import { useEffect, useState } from "react";
import config from "../devprodConfig";

export default function YmparistoTab({ kiinteisto, }) {
  const [radonData, setRadonData] = useState(null);
  const [loading, setLoading] = useState(false);

  const rakennukset =
    kiinteisto?.rakennukset || kiinteisto?.rakennukset_fulls || [];
  const radon =
    rakennukset?.[0]?.aluetiedot?.radon || null;
    const effectiveRadon = radon || radonData || null;
  const postalCode =
    kiinteisto?.rakennukset?.[0]?.postinumero ||
    kiinteisto?.rakennukset_fulls?.[0]?.postinumero ||
    kiinteisto?.postinumero ||
    null;
const cleanEtaisyys = (value) =>
  typeof value === "string"
    ? value.replace(/\s*–?\s*alueella/i, "").trim()
    : value;

  //Fetch radon data
  useEffect(() => {
    if (!postalCode) return;
    const fetchRadon = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${config.apiBaseUrl}/api/radon/${postalCode}`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Ei radondataa");
        const data = await res.json();
        setRadonData(data);
      } catch {
        setRadonData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchRadon();
  }, [postalCode]);
useEffect(() => {
  if (!radonData) return;
  if (!rakennukset.length) return;

  
  if (rakennukset[0]?.aluetiedot?.radon) return;

  console.log("⏩ SAVING RADON TO DB:", {
    rakennusId: rakennukset[0].id_rakennus,
    radonData
  });

  const saveRadonToRakennukset = async () => {
    for (const r of rakennukset) {
      await fetch(`${config.apiBaseUrl}/api/rakennukset_full/${r.id_rakennus}`, {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  credentials: "include",
  body: JSON.stringify({
    aluetiedot: {
      ...(r.aluetiedot || {}),
      radon: {
        postinumero: radonData.Postinumero,
        postitoimipaikka: radonData.Postitoimipaikka,
        mitattujaAS: radonData["Mitattuja pientaloasuntoja"],
        keskiarvo: radonData["Keskiarvo Bq/m3"],
        mediaani: radonData["Mediaani  Bq/m3"],
        yli200: radonData["200 Bq/m3 ylitykset %"],
        yli300: radonData["300 Bq/m3 ylitykset %"],
        yli1000: radonData["1000 Bq/m3 ylitykset %"],
        source: "STUK"
      }
    }
  })
});
    }
  }

  saveRadonToRakennukset();
}, [radonData, rakennukset]);

  // aluetiedot
const parseAluetiedot = (rakennukset = []) =>
  rakennukset.map((rak) => ({
    rakennustunnus:
      rak.rakennustunnus ||
      rak.Rakennustunnus ||
      rak.id_rakennus ||
      "Tuntematon",

    pohjavesi: Array.isArray(rak?.aluetiedot?.pohjavesi)
      ? rak.aluetiedot.pohjavesi
      : [],

    tulvariski: Array.isArray(rak?.aluetiedot?.tulvariski)
      ? rak.aluetiedot.tulvariski
      : [],

    maapera:
      Array.isArray(rak?.aluetiedot?.maapera)
        ? rak.aluetiedot.maapera

        : Array.isArray(rak?.aluetiedot?.["Maaperän tila"])
          ? rak.aluetiedot["Maaperän tila"]

          : Array.isArray(rak?.aluetiedot?.["Maaperän tila"]?.value)
            ? rak.aluetiedot["Maaperän tila"].value

            : Array.isArray(rak?.Maapera)
              ? rak.Maapera

              : [],
  }));


  const aluetiedot = parseAluetiedot(rakennukset);

  const display = (v) =>
    v === null || v === undefined || v === "" ? "–" : v;

const renderTulvariski = (alueet) =>
  !alueet || alueet.length === 0 ? (
    <span className="text-muted">Ei tulvariskialueella</span>
  ) : (
    <ul className="mb-0 ps-3">
      {alueet.map((a, i) => (
        <li key={i}>
          <strong>{a.lähde}</strong>: {a.nimi}
          {cleanEtaisyys(a.etäisyys) && ` – ${cleanEtaisyys(a.etäisyys)}`}
        </li>

      ))}
    </ul>
  );


const renderPohjavesi = (alueet) =>
  !alueet || alueet.length === 0 ? (
    <span className="text-muted">Ei pohjavesialueella</span>
  ) : (
    <ul className="mb-0 ps-3">
      {alueet.map((a, i) => (
        <li key={i}>
          <strong>{a.nimi}</strong> <em>({a.luokka})</em>
          {cleanEtaisyys(a.etäisyys) && ` – ${cleanEtaisyys(a.etäisyys)}`}
        </li>
      ))}
    </ul>
  );
const renderMaapera = (kohteet) =>
  !kohteet || kohteet.length === 0 ? (
    <span className="text-muted">
      Ei maaperän tilan kohteita
    </span>
  ) : (
    <ul className="mb-0 ps-3">
      {kohteet.map((kohde, i) => (
        <li key={kohde.id || i}>
          <strong>Kohde {kohde.id || "–"}</strong>

          {kohde.etäisyys && (
            <> – {kohde.etäisyys}</>
          )}

          {kohde.kunta && (
            <> – {kohde.kunta}</>
          )}

          {kohde.virasto && (
            <> – {kohde.virasto}</>
          )}
        </li>
      ))}
    </ul>
  );
useEffect(() => {
  console.log("Rakennukset ymparistotiedot:", rakennukset);
}, [rakennukset]);
  if (!postalCode)
    return <p className="text-muted p-3">Postinumero puuttuu kiinteistöltä.</p>;

  if (loading)
    return <p className="p-3 text-muted">Ladataan radondataa...</p>;

  
  return (
    <div className="p-3 d-flex flex-column gap-4">

     
      <div className="p-3 rounded-4 border border-success bg-success-subtle">
        <h5 className="fw-bold text-success-emphasis mb-3">
           Pohjavesialueet
        </h5>
        {aluetiedot.length === 0 ? (
          <p className="text-muted mb-0">Ei pohjavesitietoja saatavilla.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm align-middle mb-0">
              <thead>
  <tr className="table-success">
    <th>Rakennus</th>
    <th>Pohjavesialue</th>
  </tr>
</thead>

              <tbody>
                {aluetiedot.map((r) => (
                  <tr key={r.rakennustunnus}>
                    <td className="fw-medium">{r.rakennustunnus}</td>
                    <td>{renderPohjavesi(r.pohjavesi)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
<div className="p-3 rounded-4 border border-success bg-success-subtle">
  <h5 className="fw-bold text-success-emphasis mb-3">
    Maaperän tila
  </h5>

  {aluetiedot.length === 0 ? (
    <p className="text-muted mb-0">
      Ei maaperätietoja saatavilla.
    </p>
  ) : (
    <div className="table-responsive">
      <table className="table table-sm align-middle mb-0">
        <thead>
          <tr className="table-success">
            <th>Rakennus</th>
            <th>Maaperän tila</th>
          </tr>
        </thead>

        <tbody>
          {aluetiedot.map((r) => (
            <tr key={r.rakennustunnus}>
              <td className="fw-medium">
                {r.rakennustunnus}
              </td>

              <td>
                {renderMaapera(r.maapera)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}
</div>
      
      <div className="p-3 rounded-4 border border-success bg-success-subtle">
        <h5 className="fw-bold text-success-emphasis mb-3">
           Tulvariskialueet
        </h5>
        {aluetiedot.length === 0 ? (
          <p className="text-muted mb-0">Ei tulvariskitietoja saatavilla.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm align-middle mb-0">
              <thead>
                <tr className="table-success">
                  <th>Rakennus</th>
                  <th>Tulvariski</th>
                </tr>
              </thead>
              <tbody>
                {aluetiedot.map((r) => (
                  <tr key={r.rakennustunnus}>
                    <td className="fw-medium">{r.rakennustunnus}</td>
                    <td>{renderTulvariski(r.tulvariski)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      
      <div className="p-3 rounded-4 border border-success bg-success-subtle">
        <h5 className="fw-bold text-success-emphasis mb-3"> Radon</h5>

      {effectiveRadon ? (
  <div className="table-responsive">
    <table className="table table-sm mb-0">
      <tbody>
        <tr>
          <th>Postinumero</th>
          <td>{display(effectiveRadon.postinumero ?? effectiveRadon.Postinumero)}</td>
        </tr>
        <tr>
          <th>Postitoimipaikka</th>
          <td>{display(effectiveRadon.postitoimipaikka ?? effectiveRadon.Postitoimipaikka)}</td>
        </tr>
        <tr>
          <th>Mitattuja pientaloasuntoja</th>
          <td>{display(effectiveRadon.mitattujaAS ?? effectiveRadon["Mitattuja pientaloasuntoja"])}</td>
        </tr>
        <tr>
          <th>Keskimääräinen radon (Bq/m³)</th>
          <td>{display(effectiveRadon.keskiarvo ?? effectiveRadon["Keskiarvo Bq/m3"])}</td>
        </tr>
        <tr>
          <th>Mediaani (Bq/m³)</th>
          <td>{display(effectiveRadon.mediaani ?? effectiveRadon["Mediaani  Bq/m3"])}</td>
        </tr>
        <tr>
          <th>200 Bq/m³ ylitykset (%)</th>
          <td>{display(effectiveRadon.yli200 ?? effectiveRadon["200 Bq/m3 ylitykset %"])}</td>
        </tr>
        <tr>
          <th>300 Bq/m³ ylitykset (%)</th>
          <td>{display(effectiveRadon.yli300 ?? effectiveRadon["300 Bq/m3 ylitykset %"])}</td>
        </tr>
        <tr>
          <th>1000 Bq/m³ ylitykset (%)</th>
          <td>{display(effectiveRadon.yli1000 ?? effectiveRadon["1000 Bq/m3 ylitykset %"])}</td>
        </tr>
      </tbody>
    </table>
  </div>
) : (
  <p className="text-muted mb-0">
    Ei radondataa postinumerolle <strong>{postalCode}</strong>.
  </p>
)}

      
      </div>
    </div>
  );
}
